export const name = 'gzPlacesAutoComplete';
export default function gzPlacesAutoComplete(
  $gzGoogleMaps,
  $window,
  $rootScope,
  rnHttp,
  $q,
  $gzTime
) {
  'ngInject';

  const directive = {
    restrict: 'A',
    scope: {
      onPlaceChanged: '&?',
      pairingId: '@?',
      place: '=?',
      placeTypes: '=?',
    },
    controllerAs: 'vm',
    bindToController: true,
    link: gzPlacesAutoCompleteLink,
    controller: gzPlacesAutoCompleteController,
  };
  return directive;

  function gzPlacesAutoCompleteLink(scope, element) {
    return $q.all([
      $gzGoogleMaps.getMapsKey(),
      $gzGoogleMaps.onReady(),
    ]).then(([mapsKey]) => {
      let lastPlace;
      let autocomplete = new $window.google.maps.places.Autocomplete(element[0], {
        // TODO: allow for options
        // TODO: pair with map for bounds and watch for map changes?
      });

      scope.$watch('vm.placeTypes', placeTypes => {
        autocomplete.setTypes(placeTypes);
      });

      scope.$watch('vm.place', place => {
        autocomplete.set('place', place);
      });

      if (scope.vm.onPlaceChanged) {
        autocomplete.addListener('place_changed', () => {
          let place = autocomplete.getPlace();
          if (place === lastPlace) {
            return;
          }

          lastPlace = place;
          let config = {
            headers: {
              'If-Modified-Since': undefined,
              'Cache-Control': undefined
            },
            method: 'GET',
            url: 'https://maps.googleapis.com/maps/api/timezone/json',
            withCredentials: false,
            params: {
              key: mapsKey,
              timestamp: new Date().getTime() / 1000,
            }
          };

          let location = _.get(place, 'geometry.location');
          if (location) {
            if (_.isFunction(location.lat)) {
              _.set(config, 'params.location', location.lat() + ',' + location.lng());
            }
            else {
              _.set(config, 'params.location', location.lat + ',' + location.lng);
            }

            rnHttp.simpleRequest(config).then(resp => {
              place.gzTimeZone = $gzTime.getById(resp.data.timeZoneId);
            }).catch(() => {
              $q.resolve(true);
            }).finally(() => {
              $rootScope.$applyAsync(() => {
                scope.vm.onPlaceChanged({ $place: place });
              });
            });
          }
          else {
            $rootScope.$applyAsync(() => {
              scope.vm.onPlaceChanged({ $place: place });
            });
          }

        });
      }
      return autocomplete;
    });
  }

  // @ngInject
  function gzPlacesAutoCompleteController() {
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/google-maps/places-auto-complete.directive.js